<template>
  <div class="rtb-stats__widget">
  <SmartTableWidget
    :widget="{
          tableTitle: $t('RTT_PINGS'),
          locale: $options.i18n
      }"
    :column-defs="columns"
    :row-data="pingData || []"
    :enable-date-range-filter="false"
    :enable-export="true"
    :enable-search="true"
    :searchKeys="['rttName', 'rttId']"
    :search-placeholder="$t('INPUT_SEARCH_RTT_PLACEHOLDER')"
    :export-title="'Ring Tree Target Pings ' + dateRange[0] + '--' + dateRange[1]"
  >
   <template #table>
      <LoadingStatusDisplay
        v-if="isLoading"
      />
      <div
        v-else-if="!pingData"
        class="empty-records"
      >
        {{ $t('RTT_DASHBOARD_PANE_EMPTY') }}
      </div>
    </template>
  </SmartTableWidget>
  </div>
</template>
<script>
import LoadingStatusDisplay from '@/core/components/Loader/LoadingStatusDisplay.vue';
import SmartTableWidget from '@/core/components/SmartTable/SmartTableWidget.vue';
import messages from '../../locales';
import sharedMessages from '@/core/locales';
import { columnSettings } from '../../columnSettings'
export default {
  name: 'RingTreeTargetPings',
  components: { SmartTableWidget, LoadingStatusDisplay },
  props: {
    pingData: {
      type: Array,
      default: []
    },
    dateRange: {
      type: Array,
      default: []
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      columns: columnSettings.pingData,
      pingDates: 'Today',
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
}

</script>